<div *ngIf="reportId$ | async as reportId">
  <cap-power-bi-report [reportId]="reportId"></cap-power-bi-report>
</div>
